"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchoolParticipantActionEnum = void 0;
var SchoolParticipantActionEnum;
(function (SchoolParticipantActionEnum) {
  /** Могу снять назначение преподавателя */
  SchoolParticipantActionEnum["dismiss_teacher"] = "dismiss_teacher";
  /** Могу снять назначение владельца */
  SchoolParticipantActionEnum["dismiss_owner"] = "dismiss_owner";
  /** Могу снять назначение управляющего */
  SchoolParticipantActionEnum["dismiss_manager"] = "dismiss_manager";
  /** Могу снять назначение модератора */
  SchoolParticipantActionEnum["dismiss_moderator"] = "dismiss_moderator";
  /** Могу управлять расписанием преподавателя */
  SchoolParticipantActionEnum["manage_teacher_schedule"] = "manage_teacher_schedule";
})(SchoolParticipantActionEnum = exports.SchoolParticipantActionEnum || (exports.SchoolParticipantActionEnum = {}));
